const defaultConfig = {
  navbarWidth: 260,
  logoNavbarWidth: 40,
  mainColor: "#008000",
  mainColorBackground: "#001529",
  colorBackgroundSubNavbar: "#000C17",
};

export default defaultConfig;
